import { getDeviceType } from '@axa-fr-axion/utils';

const DATA_LAYER_COMMON_GLOBAL = {
  page_secteur: "assurance",
  page_type: "devis_generique"
};

const SEND_TAG_EVENT_NAME = "sendTag";
const EXCLUDED_KEY_TO_NORMALIZE_COMMON = [
  "form_contact_email_hash",
  "form_numero_dossier_hash",
  "nom_domaine_email"
];
const KEEPING_SPACE_KEY_TO_NORMALIZE_COMMON = [
  "form_contact_prenom_hash",
  "form_contact_nom_hash"
];
function normalizeDataLayer(data, excludedKeyToNormalize, keepingSpaceKeyToNormalize) {
  return Object.entries(data).reduce(
    (acc, pair) => {
      const [key, value] = pair;
      const withSpacing = keepingSpaceKeyToNormalize.includes(key);
      const excludedToNormalize = excludedKeyToNormalize.includes(key);
      return {
        ...acc,
        [key]: excludedToNormalize ? value : normalizeDiacriticsString(value, withSpacing)
      };
    },
    {}
  );
}
function normalizeDiacriticsString(textToChange, withSpacing = false) {
  if (textToChange === null || typeof textToChange === "undefined") {
    return "";
  }
  if (typeof textToChange !== "string") {
    return textToChange;
  }
  const text = withSpacing ? textToChange : textToChange.replace(/ +/g, "_");
  return text.toLowerCase().replace(/[\u00E0\u00E1\u00E2\u00E3\u00E4\u00E5]/g, "a").replace(/[\u00E6]/g, "ae").replace(/[\u00E7]/g, "c").replace(/[\u00E8\u00E9\u00EA\u00EB]/g, "e").replace(/[\u00F1]/g, "n").replace(/[\u00EC\u00ED\u00EE\u00EF]/g, "i").replace(/[\u00F2\u00F3\u00F4\u00F5\u00F6]/g, "o").replace(/[\u0153]/g, "oe").replace(/[\u00E6]/g, "ae").replace(/[\u00F9\u00FA\u00FB\u00FC]/g, "u").replace(/[\u00FD\u00FF]/g, "y").replace(/[^a-z0-9_;: /-]+/g, "").replace(/_+/g, "_");
}
const clearEmptyDataLayer = (data) => Object.entries(data).reduce((acc, pair) => {
  const [key, value] = pair;
  if (value === void 0 || value === "" || value === null) {
    return acc;
  }
  return {
    ...acc,
    [key]: value
  };
}, {});
function toTagEnvironnement(env) {
  switch (env) {
    case "Production":
      return "Prod";
    case "Staging":
      return "Preprod";
    case "Testing":
      return "Recette";
    case "Development":
    default:
      return "Dev";
  }
}
const getPathnameUrl = (stepName) => {
  const { pathname } = window.location;
  const pathnameWithoutExtension = pathname.replace(/\.html$/, "");
  if (!stepName) {
    return pathnameWithoutExtension;
  }
  if (pathname.endsWith("/")) {
    return `${pathnameWithoutExtension}${stepName}`;
  }
  return `${pathnameWithoutExtension}/${stepName}`;
};
const getDomain = (email) => {
  return (email || "").split("@")[1] || "";
};

const addCommmonAndEnvironmentDataLayer = (dataLayer, environment) => {
  return {
    ...DATA_LAYER_COMMON_GLOBAL,
    ...dataLayer,
    environnement: environment
  };
};
const sendTagEvent = (eventInitDict) => {
  const event = new CustomEvent(SEND_TAG_EVENT_NAME, { detail: eventInitDict });
  window.dispatchEvent(event);
};
const sendTagEventNavigationCommon = async (hashedDataLayer, navigationData, dataLayer, environment) => {
  const clearedDataLayer = clearEmptyDataLayer(hashedDataLayer);
  if (navigationData != null) {
    sendTagEvent({
      Datalayer: {
        ...addCommmonAndEnvironmentDataLayer(dataLayer, environment),
        ...navigationData,
        ...clearedDataLayer,
        device: getDeviceType(),
        page_url: getPathnameUrl(navigationData.nom_etape)
      },
      Event: "N",
      Type: "V",
      Label: navigationData.xiti_xtpage
    });
  }
};

export { DATA_LAYER_COMMON_GLOBAL, EXCLUDED_KEY_TO_NORMALIZE_COMMON, KEEPING_SPACE_KEY_TO_NORMALIZE_COMMON, SEND_TAG_EVENT_NAME, clearEmptyDataLayer, getDomain, getPathnameUrl, normalizeDataLayer, normalizeDiacriticsString, sendTagEvent, sendTagEventNavigationCommon, toTagEnvironnement };
